import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  AllRoleListResponseSchema,
  PaginatedRoleListResponseSchema,
  RoleListResponseSchema,
} from './schemas.js';

export type { RoleItem, RoleItemV2 } from './schemas.js';

export const listRoles = defaultClient.query({
  url: 'authentication/v1/roles/' as const,
  method: 'GET',
  responseSchema: RoleListResponseSchema,
  processResponse(data) {
    return data;
  },
});

// 2.0 API endpoint for listing roles.
// TODO: create one endpoint for both paginated and non paginated response
export const listPaginatedRoles = defaultClient.query({
  url: 'authentication/v2/roles/' as const,
  method: 'GET',
  responseSchema: PaginatedRoleListResponseSchema,
  querySchema: z.object({
    search: z.string().optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    ordering: z.string().optional(),
    includeInheritedTags: z.boolean().optional(),
    isAiHubIncluded: z.boolean().optional(),
  }),
  snakeCaseQueryParams: true,
});

export const listAllRolesV2 = defaultClient.query({
  url: 'authentication/v2/roles/' as const,
  method: 'GET',
  responseSchema: AllRoleListResponseSchema,
  querySchema: z.object({
    search: z.string().optional(),
    limit: z.literal(0), // Set limit to 0 to fetch all roles
    offset: z.number().optional(),
    ordering: z.string().optional(),
    isAiHubIncluded: z.boolean().optional(),
  }),
  snakeCaseQueryParams: true,
});
